/**
 * @voltxampere/ui — 4N25 Optocoupler variant (Sprint 44-4, placeholder)
 *
 * PLACEHOLDER. Phototransistor optocoupler — input side LED görünür,
 * output transistörü datasheet meta + Inspector "paired
 * phototransistor Sprint 47+" warning'i ile temsil. Engine
 * extension #4 ile (Sprint 47+'da) iki ayrı net + CTR (current
 * transfer ratio) coupling stamp aktif olur.
 *
 * Reference: ON Semi 4N25 / 4N35 — DIP-6. V_F = 1.5 V (LED), V_R(BR)
 * = 5500 V (isolation), CTR = 20% (4N25) / 100% (4N35), I_F = 60 mA
 * max. AC line isolation, MCU-MOSFET gate drive, telekom modem.
 *
 * Engine zero-diff invariant honored — canonical `led` engine type
 * via schemaType (input side).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const opto4n25 = {
    id: "4n25",
    nameTr: "4N25 (Optocoupler 6-pin DIP, CTR 20%, placeholder)",
    nameEn: "4N25 (Optocoupler 6-pin DIP, CTR 20%, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "U",
    defaultValue: "4N25",
    schemaType: "led",
    defaultParams: { saturationCurrent: 1e-12, ideality: 2 },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=opto-4n25.js.map